<template>

    <p class="form-error" v-if="field.$error">
        {{ field.$errors[0].$message }}
<!--        {{ field_name}}-->
    </p>

</template>

<script>
export default {
    name: "FormError",
    props: {
        for: {
            type: String,
            required: true
        }
    },
    data: function (){
        return {
            field_name: this.for,

        }
    },
    computed: {
        field (){
            let b = this.$parent.v$;
            let found = true;

            this.for.split('.').forEach((item)=>{

                if (b[item]) {
                    b = b[item];
                } else {
                    found = false;
                }
            })

            return found ? b : {};

        }
    }

}
</script>

<style scoped>
    .form-error {
        background-color: red;
        color:white;
        padding: 2px 5px 2px 5px;
    }
</style>
